import React from 'react';
import { Spring } from 'react-spring';
import styles from './project-hero-wipe.module.css';

const ProjectHeroWipe = ({ isHome }) => {
  if (isHome !== true) {
    return (
      <React.Fragment>
        <Spring from={{ top: '0%' }} to={{ top: '100%' }} delay={300}>
          {animation => <div className={styles.heroWipe} style={animation} />}
        </Spring>
      </React.Fragment>
    );
  } else {
    return null;
  }
};

export default ProjectHeroWipe;



// WEBPACK FOOTER //
// ./src/components/project/project-hero/project-hero-wipe/index.js